import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { handleThunkError } from "@/utils/thunkErrorHandler";
import { Params } from "@/types";
import { SettingsFormValues } from "@/types/settings";

const endpoint = {
  setting: "/setting",
};

export const fetchSetting = createAsyncThunk(
  "setting/fetchSetting",
  async (params: Params & { _path?: string } = {}, thunkAPI) => {
    try {
      // Allow callers to provide an explicit path (useful on cold reloads before AuthContext sets baseURL)
      const { _path, ...realParams } = params || {};

      // Normalize URL to avoid duplicating establishment slug when axios baseURL already contains it.
      let url = _path ? _path : endpoint.setting;
      try {
        const baseURL = axiosInstance.defaults.baseURL || "";
        const m = baseURL.match(/\/establishment\/([^/]+)/);
        if (m && _path) {
          const baseSlug = m[1];
          const prefix = `/establishment/${baseSlug}`;
          if (url.startsWith(prefix)) {
            url = url.replace(prefix, "") || endpoint.setting;
          }
        }
      } catch (e) {
        // ignore and use provided url
      }

      // Ensure url is valid for axios (fallback to endpoint.setting)
      if (!url || url === "") url = endpoint.setting;

      const response = await axiosInstance.get(url, {
        params: realParams,
      });
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Erro ao carregar configurações",
      );
    }
  },
);

export const createSetting = createAsyncThunk(
  "setting/createSetting",
  async (data: SettingsFormValues, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.setting, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error: any) {
      if (error.response?.status === 422) {
        const validationErrors = error.response.data.errors;
        if (validationErrors) {
          const errorMessages = Object.values(validationErrors)
            .flat()
            .join(", ");
          return thunkAPI.rejectWithValue({
            error: errorMessages,
            validationErrors,
            status: 422,
          });
        }
      }

      return handleThunkError(error, thunkAPI, "Erro ao salvar configurações");
    }
  },
);
